import { AxiosInstance } from "axios";
import CommonCRUD from "modules/CommonCRUD";

class CustomersReports extends CommonCRUD {}

export default CustomersReports;
